import React from "react";
import "./StatusTag.scss";

export type IntegrationStatusLabel =
  | "Not started"
  | "Completed"
  | "In progress"
  | "On hold"
  | "Not applicable"
  | "Validated - Full approval"
  | "Validated - Conditional approval"
  | "Validation - Failed";

function statusClassName(label: IntegrationStatusLabel) {
  switch (label) {
    case "Not started":
      return "not-started";
    case "Completed":
      return "completed";
    case "In progress":
      return "in-progress";
    case "On hold":
      return "on-hold";
    case "Not applicable":
      return "not-applicable";
    case "Validated - Full approval":
      return "validated-full-approval";
    case "Validated - Conditional approval":
      return "validated-conditional-approval";
    case "Validation - Failed":
      return "validation-failed";
  }
}

type StatusTagProps = {
  status: IntegrationStatusLabel;
  className?: string;
};

const StatusTag: React.FC<StatusTagProps> = ({ status, className }) => {
  const variant = statusClassName(status);
  return (
    <span
      className={["integration-status-tag", variant, className]
        .filter(Boolean)
        .join(" ")}
    >
      {status}
    </span>
  );
};

export default StatusTag;


